import { render } from "./list-share-settings-link.vue?vue&type=template&id=0020aa3a&scoped=true&ts=true"
import script from "./list-share-settings-link.vue?vue&type=script&lang=ts"
export * from "./list-share-settings-link.vue?vue&type=script&lang=ts"

import "./list-share-settings-link.vue?vue&type=style&index=0&id=0020aa3a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0020aa3a"]])

export default __exports__